import { app } from '../utils/store'
import Swiper from "swiper/bundle"

export default class Gallery {
    constructor({ element }) {
        this.element = element

        this.create(this.element)
    }

    create = (element) => {
        if (element.getAttribute('data-slider') == 'gallery' && !app.device.mobile) {
            this.carousel = new Swiper(this.element, {
                speed: 500,
                slidesPerView: 'auto',
                centeredSlides: false,
                spaceBetween: 10,
                navigation: {
                    nextEl: "[data-next]",
                    prevEl: "[data-prev]",
                    clickable: true,
                },
                // scrollbar: {
                //     el: ".swiper-scrollbar",
                //     draggable: true,
                // },
                centerInsufficientSlides: true,
                autoHeight: false,
            })
        }
    }
}